module.exports = __webpack_public_path__ + "static/img/home_19.aecf07c9.png";